import { isEmpty } from 'lodash';
import { Service } from '../types';

const hasUpfrontFields = (service: Service) => {
  return Boolean(service.hasUpfrontFields) || !isEmpty(service.upfront_fields);
};

export default hasUpfrontFields;
